/**
 * Formatea un tamaño en bytes a una cadena legible (KB, MB, etc.).
 * @param {number} bytes - Tamaño en bytes
 * @returns {string} - Ej: "200 KB", "1.5 MB"
 */
export const formatFileSize = (bytes) => {
  if (bytes === null || bytes === undefined || isNaN(bytes)) return "";
  if (bytes === 0) return "0 B";

  const units = ["B", "KB", "MB", "GB"];
  const i = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    units.length - 1
  );
  const value = bytes / Math.pow(1024, i);
  // Sin decimales para B/KB, un decimal para MB/GB
  const decimals = i < 2 ? 0 : 1;
  return `${value.toFixed(decimals)} ${units[i]}`;
};
